export default __webpack_public_path__ + "affinity-photo.6f5d4c40.png";